import React from "react";
import { Formik } from "formik";
import {
    withStyles,
    Button,
    Select,
    MenuItem,
    FormControl,
    InputLabel,
    CircularProgress
} from "@material-ui/core";
import * as Yup from "yup";

const styles = theme => ({
    root: {
        width: "auto",
        height: "auto",
        padding: theme.spacing(2),
        margin: theme.spacing(2)
    },
    rootEdit: {
        flexGrow: 1,
        paddingTop: theme.spacing(2)
    },
    submit: {
        textTransform: 'none',
        color: theme.palette.buttonText.default,
        backgroundColor: theme.palette.primary.main,
        borderRadius: '1px',
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
        },
        width: "120px",
        marginTop: "10px"
    },
    cancel: {
        width: "120px",
        marginTop: "10px",
        marginRight: "10px",
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
            color: theme.palette.buttonText.default

        }
    },
    formControl: {
        width: "100%"
    },
    buttons: {
        textAlign: "right"
    }
});

const ChangePaletteForm = props => {
    const { classes, formSettings, initialValues, changePaletteState, handleSubmit, translations } = props;

    return (
        <div className={classes.root}>
            <Formik
                enableReinitialize
                initialValues={initialValues}
                onSubmit={async (values, { setSubmitting }) => {
                    setSubmitting(true);
                    await handleSubmit(values);
                    setSubmitting(true);

                }}
                validationSchema={Yup.object().shape(formSettings.Validation)}
            >
                {formikProps => {
                    const { values, isValid, dirty, isSubmitting, handleChange, handleSubmit } = formikProps;
                    return (
                        <form onSubmit={handleSubmit}>
                            <FormControl className={classes.formControl} margin={"dense"}>
                                <InputLabel shrink>{translations["order_select"] || "Please select order"}</InputLabel>
                                <Select
                                    name="OrderID"
                                    label={translations["order"] || 'Order'}
                                    margin={"dense"}
                                    value={values.OrderID || ''}
                                    onChange={handleChange}
                                >
                                    {(changePaletteState && changePaletteState.orders ? changePaletteState.orders : []).map(option => (
                                        <MenuItem key={option.value} value={option.value}>
                                            {option.displayValue}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>

                            <FormControl className={classes.formControl} margin={"dense"}>
                                <InputLabel shrink>{translations["transport_colli_text"] || "Please select transport colli"}</InputLabel>
                                <Select
                                    name="TransportColliID"
                                    label={translations["transport_colli"] || 'Transport Colli'}
                                    margin={"dense"}
                                    value={values.TransportColliID || ''}
                                    onChange={handleChange}
                                >
                                    {(changePaletteState.orders.length > 0 ? changePaletteState.orders.filter(order => order.value === values.OrderID) : []).map(
                                        order => {
                                            return order.TransportCollies.map(option => (
                                                <MenuItem key={option.value} value={option.value}>
                                                    {option.displayValue}
                                                </MenuItem>
                                            ))
                                        }
                                    )}
                                </Select>
                            </FormControl>

                            <FormControl className={classes.formControl} margin={"dense"}>
                                <InputLabel shrink>{translations["colli_text"] || "Please select colli palette"}</InputLabel>
                                <Select
                                    name="ColliID"
                                    label={translations["colli"] || 'Colli'}
                                    margin={"dense"}
                                    value={values.ColliID || ''}
                                    onChange={handleChange}

                                >
                                    {(changePaletteState && changePaletteState.Collies ? changePaletteState.Collies : []).map(option => (
                                        <MenuItem key={option.value} value={option.value}>
                                            {option.displayValue}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            <div style={{ textAlign: "right" }}>
                                {formSettings.ButtonCancel ? (
                                    <Button
                                        className={classes.cancel}
                                        variant="contained"
                                        color={formSettings.ButtonCancel.Color}
                                        onClick={formSettings.ButtonCancel.handleCancel}
                                    >
                                        {formSettings.ButtonCancel.Title}
                                    </Button>
                                ) : null
                                }
                                {formSettings.ButtonSubmit ? (
                                    <Button
                                        className={classes.submit}
                                        variant="contained"
                                        type="submit"
                                        disabled={!(isValid && dirty) || isSubmitting}
                                    >
                                        {isSubmitting ? <CircularProgress size={24} /> : formSettings.ButtonSubmit.Title}
                                    </Button>
                                ) : null}
                            </div>
                        </form>
                    );
                }}
            </Formik>
        </div>
    );
};

export default withStyles(styles, { withTheme: true })(ChangePaletteForm);
